import clsx from "clsx";
import { useArchiveContext } from "../../context/archive.context";
import {decodeHtml} from "../../utils/helpers";

export const Post = ({ data }) => {
	const { lang } = useArchiveContext();

	const isVideo = data.postType === "video";
	// console.log(data);

	const hasImage = !!data.imageMarkup.length;

	const backgroundColor = isVideo ? "#FAAC74" : "#F26648";
	return (
		<div className="singleElementResources-2">
			<div className="video-40 singleElement-48 fadeIn-10">
				<div
					className={clsx({
						"imageWrapper-42": true,
						videoShape: isVideo,
					})}
					style={{ position: "relative" }}
				>
					<svg
						width="100%"
						viewBox="0 0 330 220"
						fill="none"
						preserveAspectRatio="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M4.33614 0C110.925 1.24682 217.513 2.40458 324.102 3.6514C318.098 69.0204 330 136.26 330 210H6.86393C-6.9336 143.295 4.33614 65.9924 4.33614 0Z"
							fill={backgroundColor}
						/>
					</svg>

					<div
						className={clsx({ "imageContainer-43": true, mask: isVideo })}
						style={{
							overflow: "hidden",
							position: "absolute",
							top: 15,
							left: 15,
							right: 15,
							bottom: 30,
						}}
					>
						{hasImage ? (
							<div dangerouslySetInnerHTML={{ __html: data.imageMarkup }}></div>
						) : (
							<svg
								preserveAspectRatio="xMidYMid slice"
								viewBox="0 0 330 210"
								x="0"
								y="0"
								className="imageSrc"
							>
								<defs>
									<clipPath id="shapeaf91045f-6e6d-4935-b687-cc56716368d5">
										<rect
											x="0"
											y="0"
											width="330"
											height="210"
											fill="yellow"
										></rect>
									</clipPath>
								</defs>
							</svg>
						)}

						{isVideo && (
							<svg
								className="playButton-41 videoPlay"
								xmlns="http://www.w3.org/2000/svg"
								width="44"
								height="43"
								viewBox="0 0 44 43"
								fill="none"
							>
								<mask id={"path-1-inside-22"} fill="white">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M6.65091 2.98316C9.99468 0.00473003 18.8534 -0.0408039 23.0384 0.00935282C27.2233 0.0597407 34.2157 2.109 36.9739 5.87399C39.688 9.57797 43.4111 15.8658 43.7578 20.7551C44.0114 24.3356 44.414 29.253 42.8569 32.394C41.1936 35.7492 36.7472 39.8759 34.1171 41.593C28.9431 44.9706 12.4502 41.7049 7.55824 37.7217C-1.92711 29.9982 -2.76887 11.3741 6.65091 2.98316Z"
									/>
								</mask>
								<path
									d="M23.0384 0.00935282L23.0746 -2.99043L23.0744 -2.99043L23.0384 0.00935282ZM36.9739 5.87399L34.5539 7.64694L34.554 7.64717L36.9739 5.87399ZM43.7578 20.7551L46.7503 20.543L46.7502 20.5429L43.7578 20.7551ZM42.8569 32.394L45.5448 33.7264L45.5448 33.7264L42.8569 32.394ZM34.1171 41.593L35.757 44.1051L35.7571 44.105L34.1171 41.593ZM7.55824 37.7217L5.66401 40.048L5.66404 40.048L7.55824 37.7217ZM8.64631 5.22333C9.02938 4.88212 9.75205 4.48205 10.9197 4.12109C12.0536 3.77055 13.4127 3.51545 14.8854 3.33931C17.8336 2.98673 20.9283 2.98428 23.0025 3.00914L23.0744 -2.99043C20.9635 -3.01573 17.5364 -3.02049 14.1729 -2.61824C12.4899 -2.41695 10.7458 -2.10535 9.14753 -1.61124C7.58291 -1.12754 5.94432 -0.405007 4.6555 0.742994L8.64631 5.22333ZM23.0023 3.00914C24.7008 3.02959 27.1484 3.47307 29.48 4.35477C31.8703 5.25867 33.6751 6.44746 34.5539 7.64694L39.394 4.10104C37.5145 1.53554 34.4439 -0.1828 31.6023 -1.25737C28.7019 -2.35415 25.5609 -2.96049 23.0746 -2.99043L23.0023 3.00914ZM34.554 7.64717C35.8311 9.39005 37.3441 11.7411 38.5664 14.2038C39.8143 16.718 40.6328 19.0987 40.7653 20.9673L46.7502 20.5429C46.536 17.5222 45.3197 14.3144 43.9408 11.5363C42.5364 8.70675 40.8308 6.0619 39.3938 4.10082L34.554 7.64717ZM40.7653 20.9671C40.8951 22.8 41.0445 24.7615 40.9877 26.6491C40.9297 28.5783 40.6587 30.0738 40.1691 31.0615L45.5448 33.7264C46.6122 31.5732 46.9185 29.0395 46.985 26.8296C47.0528 24.5782 46.8741 22.2906 46.7503 20.543L40.7653 20.9671ZM40.1691 31.0615C39.5469 32.3165 38.2789 33.9193 36.7171 35.4976C35.18 37.051 33.5738 38.3649 32.4771 39.081L35.7571 44.105C37.2905 43.1039 39.2226 41.4959 40.982 39.7179C42.7168 37.9647 44.5037 35.8266 45.5448 33.7264L40.1691 31.0615ZM32.4772 39.0809C31.8681 39.4785 30.5277 39.8769 28.3365 39.9762C26.2493 40.0709 23.7668 39.8798 21.2225 39.458C18.6855 39.0374 16.1738 38.4019 14.0389 37.6516C11.8433 36.8801 10.2775 36.0671 9.45244 35.3953L5.66404 40.048C7.28498 41.3679 9.61522 42.4568 12.0496 43.3123C14.5447 44.1891 17.3968 44.9057 20.2412 45.3772C23.0784 45.8476 25.995 46.0886 28.6083 45.9701C31.1176 45.8563 33.779 45.3963 35.757 44.1051L32.4772 39.0809ZM9.45247 35.3953C5.56317 32.2285 3.21237 26.5705 3.01354 20.5045C2.81493 14.4451 4.78451 8.66336 8.64637 5.22328L4.65545 0.743042C-0.90247 5.69394 -3.2219 13.4197 -2.98324 20.701C-2.7448 27.9756 0.0679583 35.4914 5.66401 40.048L9.45247 35.3953Z"
									fill="white"
									mask={"url(#path-1-inside-22)"}
								/>
								<g clipPath={"url(#clip0)"}>
									<path
										d="M28.1701 21.3514L17.7142 26.7317V15.9686L28.1701 21.3514Z"
										fill="white"
										stroke="white"
										strokeWidth="4"
									/>
								</g>
								<defs>
									<clipPath id={"clip0"}>
										<rect
											width="15.2509"
											height="15.1777"
											fill="white"
											transform="translate(15.7142 13.7627)"
										/>
									</clipPath>
								</defs>
							</svg>
						)}
					</div>
				</div>
				<div
					className="title-cnt"
					style={{ display: "flex", alignItems: "center" }}
				>
					<svg
						width="26"
						height="20"
						viewBox="0 0 26 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10.5588 15.4571L10.9506 16.905L10.9507 16.9049L10.5588 15.4571ZM11.0774 8.48989L11.073 9.98988L11.0731 9.98988L11.0774 8.48989ZM9.37157 8.81049L8.62287 7.51071L8.62234 7.51101L9.37157 8.81049ZM8.38768 9.46393L7.72851 8.11652L7.72836 8.1166L8.38768 9.46393ZM6.87238 9.61199L6.93858 8.11345L6.93825 8.11344L6.87238 9.61199ZM22.9324 2.97975L22.774 4.47137L22.7742 4.47139L22.9324 2.97975ZM0.685729 18.9363C2.79262 19.9391 4.8342 19.4265 6.48612 18.7732C7.30395 18.4497 8.14592 18.0404 8.86863 17.7104C9.6282 17.3635 10.3056 17.0796 10.9506 16.905L10.1669 14.0091C9.26972 14.252 8.40459 14.6243 7.62242 14.9815C6.80337 15.3555 6.10433 15.6981 5.38283 15.9834C3.95609 16.5477 2.92576 16.68 1.97508 16.2275L0.685729 18.9363ZM10.9507 16.9049C12.9742 16.3572 15.0118 16.7787 17.581 17.159C20.0212 17.5203 22.8665 17.8094 25.7037 16.3021L24.2963 13.6527C22.3874 14.6668 20.4134 14.5457 18.0203 14.1914C15.7561 13.8562 12.9462 13.2568 10.1668 14.0092L10.9507 16.9049ZM24.3673 7.0266C19.9387 7.01436 15.5104 7.00255 11.0817 6.9899L11.0731 9.98988C15.502 10.0025 19.9308 10.0144 24.359 10.0266L24.3673 7.0266ZM11.0818 6.9899C10.5513 6.98833 9.57934 6.95975 8.62287 7.51071L10.1203 10.1103C10.2843 10.0158 10.4623 9.98808 11.073 9.98988L11.0818 6.9899ZM8.62234 7.51101C8.36903 7.65706 8.12537 7.84156 7.99539 7.93654C7.82544 8.06072 7.7603 8.10097 7.72851 8.11652L9.04685 10.8113C9.34704 10.6645 9.60886 10.4731 9.76537 10.3588C9.96185 10.2152 10.0441 10.1542 10.1208 10.11L8.62234 7.51101ZM7.72836 8.1166C7.72492 8.11828 7.69616 8.1346 7.57772 8.13894C7.51388 8.14128 7.43612 8.13987 7.32632 8.13446C7.27115 8.13174 7.21579 8.12845 7.14934 8.12459C7.08589 8.12091 7.0133 8.11676 6.93858 8.11345L6.80619 11.1105C7.10154 11.1236 8.11438 11.2676 9.047 10.8113L7.72836 8.1166ZM6.93825 8.11344C4.77738 8.01846 2.6809 8.71966 0.7341 10.0715L2.4452 12.5357C3.95509 11.4872 5.41629 11.0494 6.80652 11.1105L6.93825 8.11344ZM1.23699 4.0783C8.31036 2.94652 15.4317 3.69204 22.774 4.47137L23.0907 1.48813C15.8155 0.715923 8.29543 -0.0892566 0.763005 1.11598L1.23699 4.0783ZM22.7742 4.47139C23.2517 4.52202 23.7295 4.57264 24.2072 4.62326L24.5234 1.63996C24.0456 1.58934 23.5679 1.53873 23.0905 1.48811L22.7742 4.47139Z"
							fill={backgroundColor}
						/>
					</svg>
					<h4
						style={{ paddingLeft: 10, color: backgroundColor }}
						className="
                MuiTypography-root
                category-44
                videoCategory
                MuiTypography-body2
            "
					>
						{decodeHtml(  data.category || "Category")}
					</h4>
				</div>

				<h3
					className="
                MuiTypography-root
                title-45
                MuiTypography-body1
            "
				>
					<a variant="body2" className="readMore-47" href={data.link || "#"}>
						{data.title ? decodeHtml(data.title) : "Default title"} </a>
				</h3>
				<p className="source-46">{data.date || "22.02.2002"}</p>
				<a variant="body2" className="readMore-47" href={data.link || "#"}>

					{lang.toLowerCase() === "ar" ? "المزيد" : "Read more"}

					<svg
						className="r180deg"
						width="44"
						height="16"
						fill="#111111"
						viewBox="0 0 44 16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							stroke="#111111"
							fill="#111111"
							d="M32.6878 16L31.3087 14.5428L32.0046 13.8844C34.2658 11.755 36.0985 10.1288 37.5356 8.98827L36.9872 8.95283C31.3943 8.60814 29.3931 8.43266 27.3906 8.41576C24.4479 8.39093 21.5024 8.70854 7.15242 9.33485L0.134119 9.64727L0.0446777 7.64102L11.1235 7.15492C23.7704 6.62619 26.1678 6.36863 28.5599 6.41013C30.2872 6.4401 32.0117 6.62598 37.5897 6.97826L37.9276 7.00035C34.5341 4.23789 32.8235 1.95848 32.8235 9.53674e-07H34.8278L34.8321 0.115196C34.9361 1.52154 36.9138 3.79001 40.8039 6.69435L41.47 7.18425L43.0447 8.32584L41.2033 8.94909L41.1236 8.97844C40.1024 9.3831 37.6425 11.3662 33.9341 14.8262L32.6878 16ZM38.9888 7.83767L39.037 7.87498L38.9838 7.91134L38.9888 7.83767Z"
						></path>
					</svg>
				</a>
			</div>
		</div>
	);
};
